import { EFinancingCompany } from '@if/core/types'
import { DashboardLayout, Logo, mockLogin, type ProfileMenuAction } from '@if/mui'
import { Stack } from '@mui/material'
import AlertBannerProvider from '@src/providers/AlertBannerProvider'
import { reportErrorToConsole } from '@src/services/error-logger'
import { isProd, useDevTools } from '@src/types/constants'
import { UserCog } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'
import CompanySelector, { useHasCompanyChoice } from './CompanySelector'
import MockUserPicker from './Components/MockUserPicker'
import SimulatedDateChip from './SimulatedDateChip'
import useNavSections from './useNavSections'

const TemplateGlobal = () => {
  const { t } = useTranslation()
  const nav = useNavSections()
  const hasCompanyChoice = useHasCompanyChoice()
  const [isMockUserDialogOpen, setIsMockUserDialogOpen] = useState(false)

  // The one app-specific profile entry — Logout is the library's, and Loan has no
  // profile page to wire `onProfileAction` to.
  const profileMenuItems: ProfileMenuAction[] = useDevTools
    ? [{ label: t('login.mockLogin'), icon: UserCog, onClick: () => setIsMockUserDialogOpen(true) }]
    : []

  const handleMockLogin = (username: string, companyIds: EFinancingCompany[]) => {
    mockLogin({ username, password: 'ok', companyIds }).catch(reportErrorToConsole)
  }

  return (
    <>
      {/* `drawer`: the nav overlays at every width, so the calendar and the grids keep
          the full content width they have today. */}
      <DashboardLayout
        sidebar="drawer"
        logo={<Logo company={EFinancingCompany.IFinance} background="dark" width={110} />}
        nav={nav}
        appTitle={t('menus.appTitle')}
        version={__APP_VERSION__}
        onProfile={{ menuItems: profileMenuItems }}
        endSlot={
          hasCompanyChoice || !isProd ? (
            <Stack direction="row" spacing={1.5} alignItems="center">
              <SimulatedDateChip />
              {hasCompanyChoice && <CompanySelector />}
            </Stack>
          ) : undefined
        }
      >
        <AlertBannerProvider>
          <Outlet />
        </AlertBannerProvider>
      </DashboardLayout>
      <MockUserPicker
        open={isMockUserDialogOpen}
        onMockedLoginSelected={handleMockLogin}
        onClose={() => setIsMockUserDialogOpen(false)}
      />
    </>
  )
}

export default TemplateGlobal
